import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiClient } from '../api-client.config';
import { queryKeys, type RequestBody, type ResponseBody } from '../react-query.config';
import { toast } from 'sonner';
import { useNavigate } from '@tanstack/react-router';

type CreatePickemRequest = RequestBody<'/api/admin/pickems', 'post'>;
type CreatePickemResponse = ResponseBody<'/api/admin/pickems', 'post'>;

export const createPickem = (data: CreatePickemRequest) =>
  apiClient.post('/api/admin/pickems', data);

export const useCreatePickemMutation = () => {
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  return useMutation<CreatePickemResponse, Error, CreatePickemRequest>({
    mutationFn: createPickem,
    onSuccess: response => {
      queryClient.invalidateQueries({ queryKey: queryKeys.pickems.all });
      toast.success('Pickem created successfully');
      navigate({
        to: '/dashboard/pickems/$id',
        params: { id: response.pickem.pickem_id },
        search: { tenant_id: undefined, tab: undefined },
      });
    },
    onError: (error: any) => {
      toast.error(error.message || 'Failed to create pickem');
    },
  });
};
